import { FunctionComponent, useEffect, useState } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import moment, { Moment } from 'moment-timezone'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import styles from './datePickerDialog.module.scss'
import { DayPicker, Matcher } from 'react-day-picker'
import { getDaycareWeekClosingDay } from '@/modules/helper/daycareHelper'
import { Daycare } from '@/types/Daycare'
import { getLocalFromLanguage } from '@/modules/helper/languageHelper.ts'

interface DatePickerDialogProps {
    open: boolean
    handleClose: () => void
    selectedDate: Moment
    handleDateChange: (date: Moment) => void
    currentDaycare: Daycare
    parent?: boolean
}

const DatePickerDialog: FunctionComponent<DatePickerDialogProps> = ({
    open,
    handleClose,
    selectedDate,
    handleDateChange,
    currentDaycare,
    parent = false
}: DatePickerDialogProps) => {
    const [disabled, setDisabled] = useState<Matcher[]>([])

    useEffect(() => {
        setDisabled([
            {
                dayOfWeek: [...getDaycareWeekClosingDay(currentDaycare).map((day) => day)]
            }
        ])
    }, [currentDaycare])

    function onChange(date: Date): void {
        handleDateChange(moment(date))
        handleClose()
    }

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DayPicker
                defaultMonth={selectedDate.toDate()}
                disabled={disabled}
                mode='single'
                locale={getLocalFromLanguage()}
                selected={selectedDate.toDate()}
                onSelect={onChange}
                required={true}
                modifiersClassNames={{
                    selected: parent ? styles.SelectedDayParent : styles.SelectedDayDaycare,
                    hideDays: styles.HiddenDay,
                    today: styles.Today
                }}
                className={parent ? styles.DayPickerParent : styles.DayPickerDaycare}
            />
            <div className={styles.ButtonContainer}>
                <ButtonTextIcon type={'close'} onClick={handleClose} parent={parent} />
            </div>
        </Dialog>
    )
}

export default DatePickerDialog
